export default "<p>company-table works!</p>\r\n";